import { some, map, size } from 'lodash';
import React from 'react';
import { compose } from '@wordpress/compose';
import { withDispatch, withSelect } from '@wordpress/data';

import './add-to-playlist.scss';


class addToPlaylist extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onNewPlaylistTitleChange = this.onNewPlaylistTitleChange.bind(this);

    this.state = {
      newPlaylistTitle: '',
    };
  }

  onNewPlaylistTitleChange(e) {
    const value = e.target.value;

    this.setState({
      newPlaylistTitle: value,
    })
  }

  render() {
    const { newPlaylistTitle } = this.state;
    const { playlists, track, cancel, addTrackToPlaylist, removeTrackFromPlaylist, addNewPlaylist } = this.props;

    return (
      <div className="floating-playlist">
        <div className="floatingboxtitle">Add to Playlist <i className="fas fa-times-circle floatingclose" onClick={cancel}></i></div>
        <div className="floatingplaylists">
          <ul className="flplaylists">
          {map(playlists, playlist => {
            const isTrackAdded = some(playlist.tracks, playlistTrack => playlistTrack.trackKey === track.trackKey);

            return (
              <li
                key={playlist.id}
                className="playlist-single"
              >
                <div className="playlist-item">
                  <span className="playlist-item-title">{playlist.title}</span>
                  <span className="playlist-item-count">{size(playlist.tracks)} Tracks</span>
                </div>
                <div className="playlist-item-action">
                  {isTrackAdded &&
                    <div
                      className="playlist-add add song_added"
                      onClick={() => {
                        removeTrackFromPlaylist(track.trackKey, playlist.id);
                      }}
                    >Added</div>}
                  {!isTrackAdded &&
                    <div
                      className="playlist-add add"
                      onClick={() => {
                        addTrackToPlaylist(track, playlist.id);
                      }}
                    >Add</div>}
                </div>
              </li>
            );
          })}
          </ul>
        </div>
        <div className="floatingfooter">
          <div>
            <div className="footerpl">
              <div className="footerplcolumn">
                <input
                  type="text"
                  className="newlistname"
                  placeholder="New Playlist"
                  value={newPlaylistTitle}
                  onChange={this.onNewPlaylistTitleChange}
                />
                <div
                  className="newplaylist"
                  onClick={() => {
                    addNewPlaylist(newPlaylistTitle);
                    this.setState({
                      newPlaylistTitle: '',
                    });
                  }}
                >
                  <img src="/wp-content/themes/hifi-flavor/img/hifi-addtoplaylist-icon.png" />
                  New Playlist
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const AddToPlaylist = compose(
  withSelect(select => {
    const { getPlaylists } = select('hifi');

    return {
      playlists: getPlaylists(),
    };
  }), withDispatch(dispatch => {
    const { addNewPlaylist, addTrackToPlaylist, removeTrackFromPlaylist } = dispatch('hifi');

    return {
      addTrackToPlaylist,
      addNewPlaylist,
      removeTrackFromPlaylist,
    };
  }))(addToPlaylist);

export default AddToPlaylist;